import { useState } from 'react';

/**
 * Stemma di squadra: decorativo (alt vuoto — il nome è sempre accanto),
 * lazy, e se l'immagine non carica sparisce senza lasciare buchi.
 */
export function Crest({
  url,
  size = 20,
  className = '',
}: {
  url?: string | null | undefined;
  size?: number | undefined;
  className?: string | undefined;
}) {
  const [failed, setFailed] = useState(false);
  if (!url || failed) return null;
  return (
    <img
      src={url}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`inline-block shrink-0 object-contain align-[-0.2em] ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
